import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { Navigation } from "./components/navigation";
import { Navi } from "./components/navi";

import Home from "./Home.jsx";
import Terms from "./Terms.jsx";
import PolicyCompo from "./PolicyCompo.jsx";

import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  return (
    <Router basename="/">
      <Routes>
        {/* HOME → Navigation */}
        <Route
          path="/"
          element={
            <>
              <Navigation />
              <Home />
            </>
          }
        />

        {/* TERMS → Navi */}
        <Route
          path="/terms"
          element={
            <>
              <Navi />
              <Terms />
            </>
          }
        />

        {/* POLICY → Navi */}
        <Route
          path="/policy"
          element={
            <>
              <Navi />
              <PolicyCompo />
            </>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
